/**
 * Product card image carousel: loop + click handling
 */
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-product-card-carousel-id][data-direction]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var carouselId = btn.getAttribute('data-product-card-carousel-id');
    var carousel = document.getElementById(carouselId);
    if (!carousel || typeof carousel.select !== 'function') return;

    var direction = btn.getAttribute('data-direction');
    var len = (carousel.cells || []).length;
    if (len === 0) return;

    var nextIndex;
    if (direction === 'prev') {
      nextIndex = carousel.selectedIndex <= 0 ? len - 1 : carousel.selectedIndex - 1;
    } else {
      nextIndex = carousel.selectedIndex >= len - 1 ? 0 : carousel.selectedIndex + 1;
    }
    carousel.select(nextIndex);
  }, true);
});
